export const domainToURL = (domain: string) => {
  if (!domain.startsWith('http')) domain = `https://${domain}`;
  return new URL('/', domain).origin;
};

export function getSubdomain(): string | null {
  const host = window.location.hostname;
  const parts = host.split('.')[0];

  if (parts) {
    return parts;
  }

  return null;
}
